import React from "react";
import { Card, Tooltip } from "@multiagentbook/ui";
import { Usecase } from "./types";
import { getFrameworkInfo } from "./detail";
import { TruncatableText } from "@multiagentbook/ui";

interface UsecaseCardProps {
  usecase: Usecase;
  onClick: (usecase: Usecase) => void;
  index?: number;
}

const UsecaseCard: React.FC<UsecaseCardProps> = ({
  usecase,
  onClick,
  index = 3,
}) => {
  // Extract unique frameworks from implementations
  const frameworks = Array.from(
    new Set(usecase.implementations.map((impl) => impl.framework))
  );

  return (
    <div
      className="cursor-pointer transition-all duration-200 border-secondary p-4 hover:bg-secondary border rounded-lg flex gap-4"
      onClick={() => onClick(usecase)}
    >
      <div className="flex-shrink-0">
        <img
          alt=""
          src={`/images/news/icon_${index}.webp`}
          className="pointer-events-none object-cover group-hover:opacity-75 w-12 h-full rounded"
        />
      </div>
      <div className="flex-1">
        <h3 className="text-lg font-semibold mb-2">{usecase.title}</h3>
        <div className="text-sm text-secondary mb-4 line-clamp-2">
          <TruncatableText content={usecase.description} />
        </div>

        <div className="flex flex-wrap gap-2 mb-3 divide-x items-center">
          {frameworks.length <= 2
            ? frameworks.map((framework, index) => {
                const frameworkInfo = getFrameworkInfo(framework);
                return (
                  <span
                    key={framework + index}
                    className="text-xs pl-2 first:pl-0 last:pr-0 inline-block"
                    title={frameworkInfo.description}
                  >
                    {frameworkInfo.name}
                  </span>
                );
              })
            : frameworks.slice(0, 2).map((framework, index) => {
                const frameworkInfo = getFrameworkInfo(framework);
                return (
                  <span
                    key={framework + index}
                    className="text-xs pl-2 first:pl-0 last:pr-0 inline-block"
                    title={frameworkInfo.description}
                  >
                    {frameworkInfo.name}
                  </span>
                );
              })}
          {frameworks.length > 2 && (
            <span className="text-xs pl-2 text-secondary">
              ({frameworks.length} frameworks)
            </span>
          )}
        </div>

        <div className="bg-secondary h-1 mb-2 rounded"></div>
        <div className="flex flex-wrap divide-x gap-1  bg-secpondary rounded ">
          {usecase.tags.map((tag, index) => (
            <span
              key={tag + index}
              className="text-xs text-primary pl-2 first:pl-0 last:pr-0  "
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UsecaseCard;
